import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { ActionBar, AttendanceIcon, Content, DashList, DataListWrap, Img, Tag, Tags, Td, TitleLeft } from './RegistrationDetails.styled';
import moment from 'moment';
import { useStore } from '@store/appStore';
import db from '@utils/db';
import StudentThumbnail from '@components/StudentThumbnail';
import Missing from '@assets/svg/match/missing.svg';
import Late from '@assets/svg/match/late.svg';
import Attending from '@assets/svg/match/attending.svg';
import More_Icon from "@assets/svg/more.svg";
import Note_Icon from "@assets/svg/notes.svg";
import Profile_Icon from "@assets/svg/profile.svg";
import Pagination from '../Pagination';
import SortArrow from '../SortArrow';
import fixedNumber from '@utils/fixedNumber';
import { AttendanceMap } from '@models/AttendanceType';
import { TagPill, TagPills } from '@components/Note/Message/Message.styled';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import EmptyBox from '../EmptyBox';
import Teams_Icon from "@assets/svg/teams.svg";
import S_Icon from "@assets/svg/s_icon.svg";
import { CheckBox, CheckboxIcon, DateContainer, FilterBox, FilterButton, FilterButtons, FilterDrop, FilterDropHead, FilterDropInput, FilterInfo, FilterInput, FilterItem, FilterReset, FilterText, QuickBtn } from '../SchoolLeader.styled';
import Tooltip from '@components/Tooltips/Tooltip';
import Tooltip_Icon from "@assets/svg/new_exclam1.svg";
import DateSelect from '../StudentDetails/DateSelect';
import { DateSelector, SubTitle } from '../StudentDetails/StudentDetails.styled';
import Cal_Icon from "@assets/svg/new_calendar.svg"
import { ShowabsenceOrAttendance } from '@utils/percentageTools';
import { GenerateExcelFile } from '../excel';
import { MoreTags } from '../NoteDetails/NoteDetails.styled';

interface IProps { getRegistrations: () => void, loading: boolean, handleClick: (username, id, displayname, type, sick?) => void }

export const RegistrationDetails = forwardRef((props: IProps, ref) => {
  useImperativeHandle(ref, () => ({
    exportExcel() {
      Excel()
    },
  }));
  const { client, settings, callNameSetting, setNoteUserId, setNote, handleNote, filterDate, schoolViewRegistrations, setSchoolViewRegistrations, schoolViewTags, schoolViewFilter, setSchoolViewFilter, page, setPage, systemSettings } = useStore();
  const [sort, setSort] = useState({ type: 3, direction: true })
  const pageSize = 13;
  const i18n = useI18n();
  const tagsCount = useRef(0)
  const icons = {
    late: <Late />,
    missing: <Missing />,
    attending: <Attending />,
  };
  let freeTextNotes = systemSettings?.find(s => s.APP_Setting_ID === 42)
  let studentCallName = systemSettings?.find(s => s.APP_Setting_ID === 48).value
  useEffect(() => {
    getRegistrations()
  }, [filterDate, schoolViewFilter.quickdays, schoolViewFilter.quickfilter3, schoolViewFilter.fromDate3, schoolViewFilter.toDate3]);

  const ConvertTags = (list: any, index: any, extra?:boolean) => {
    if (list === null || list.length < 0) return [];

    let ids = list.split(',');
    let ttags = [];
    
    for (let i = 0; i < ids.length; i++) {
      let tempTag = schoolViewTags.find((t) => t.tag_id == ids[i]);
      if (tempTag) {
        ttags.push(tempTag);
      }
      else if (ids[i] == 99){
        ttags.push({ tag_id: 99, name: "Late", html_color: "FED425" })
      }
    }

    let tempTags = []  
    let tempExtra = []
    ttags.map((t, i) => {
        if(i > 2){
          tempExtra.push(<Tag marginBot={true} key={index + "_tag_" + i} bg={t.html_color} colors={t.html_color === "FED425"}>{i18n.t("tag-" + t.name)}</Tag>)
        } else {
          tempTags.push(<Tag key={index + "_tag_" + i} bg={t.html_color} colors={t.html_color === "FED425"}>{i18n.t("tag-" + t.name)}</Tag>)
        }
      }
    )
    
    if(extra){
      return tempExtra
    } else {
      tagsCount.current = ttags.length
      return tempTags
    }
  };

  const ConvertTagsText = (list: any) => {
    if (list === null || list.length < 0) return [];

    let ids = list.split(',');
    let tags = [];
    for (let i = 0; i < ids.length; i++) {
      let tempTag = schoolViewTags.find((t) => t.tag_id == ids[i]);
      if (tempTag) {
        tags.push(tempTag);
      }
      else if (ids[i] == 99) tags.push({ tag_id: 99, name: "Late", html_color: "FED425" })
    }
    let string = tags.map((t, i) => i18n.t("tag-" + t.name)).join(", ")
    return string.length === 0 ? " " : string;
  };

  const getFilteredRegistrations = () => {
    let registrationsTemp = JSON.parse(JSON.stringify(schoolViewRegistrations))
    registrationsTemp = registrationsTemp
      ?.filter(s => s.student_displayname?.toLowerCase().includes(schoolViewFilter.search3?.toLowerCase()))
      ?.filter(s => schoolViewFilter.types.includes(s.absence_type) || schoolViewFilter.types.length === 0)
      ?.filter(s => schoolViewFilter.courses3.includes(s.course_id) || schoolViewFilter.courses3.length === 0)
    return registrationsTemp
  }

  const getRegistrations = async () => {
    await props.getRegistrations()
  }

  function handleSort(type) {
    let direction = false;
    if (type === sort.type) direction = !sort.direction
    setSort({ type: type, direction: direction })
  }

  function getSortedRegistrations() {
    let registrationsTemp = getFilteredRegistrations()
    registrationsTemp = registrationsTemp?.sort((a, b) => {
      let dir = sort.direction ? -1 : 1
      switch (sort.type) {
        case 0:
          if (a.student_displayname > b.student_displayname) return 1 * dir
          else if (a.student_displayname < b.student_displayname) return -1 * dir
          else return 0
          break;
        case 1:
          if (a.course_name > b.course_name) return 1 * dir
          else if (a.course_name < b.course_name) return -1 * dir
          else return 0
          break;
        case 2:          
          if (a.date > b.date) return 1 * dir
          else if (a.date < b.date) return -1 * dir
          else if (a.starttime > b.starttime) return 1 * dir
          else if (a.starttime < b.starttime) return -1 * dir
          else if (a.endtime > b.endtime) return 1 * dir
          else if (a.endtime < b.endtime) return -1 * dir
          else return 0
          break;
        case 3:
          if (a.last_registertime > b.last_registertime) return 1 * dir
          else if (a.last_registertime < b.last_registertime) return -1 * dir
          else return 0
          break;
        case 4:
          if (a.course_description > b.course_description) return 1 * dir
          else if (a.course_description < b.course_description) return -1 * dir
          else return 0
          break;
        case 5:
          if (a.absence_type > b.absence_type) return 1 * dir
          else if (a.absence_type < b.absence_type) return -1 * dir
          else return 0
          break;
        case 6:
          if (a.text > b.text) return 1 * dir
          else if (a.text < b.text) return -1 * dir
          else return 0
          break;
        case 7:
          if (a.tag_ids > b.tag_ids) return 1 * dir
          else if (a.tag_ids < b.tag_ids) return -1 * dir
          else return 0
          break;
        case 8:
          if (a.teams_bit) return 1 * dir
          else return -1 * dir
          break;
      }
    })
    return registrationsTemp
  }

  const getTextCount = () => {
    let count = getFilteredRegistrations()?.length
    let totalCount = schoolViewRegistrations?.length
    if (totalCount === count && count > 0) {
      return `${i18n.t('showing')} ${i18n.t('all').toLowerCase()} ${totalCount}`
    }
    else {
      if (count > 0) {
        return `${i18n.t('showing')} ${count} ${i18n.t('of')} ${totalCount}`
      }
      else
        return ""
    }
  }

  const Excel = () => {
    let data = getSortedRegistrations().map(r => {
      let object = {}

      let absencetype = ""
      switch (r.absence_type) {
        case 2:
          absencetype = i18n.t("registration-type-absence");
          break;
        case 3:
          absencetype = i18n.t("registration-type-late");
          break;
        case 1:
          absencetype = i18n.t("registration-type-present");
          break;
      }

      object[i18n.t("header-name")] = r.student_displayname;
      object[i18n.t("date")] = moment(r.date).format('DD-MM-YYYY');
      object[i18n.t("time")] = moment.utc(moment.duration(r.starttime).as('milliseconds')).format('HH:mm') + " - " + moment.utc(moment.duration(r.endtime).as('milliseconds')).format('HH:mm');
      object[i18n.t("course")] = r.course_name;
      object[i18n.t("registration-course")] = r.course_description;
      if (settings.AUTOTEAMSREADY) {
        object[i18n.t("teams")] = r.teams_bit;
      }
      object[i18n.t("header-reg")] = absencetype;
      object[i18n.t("header-tags")] = ConvertTagsText(r.tag_ids);
      if (freeTextNotes.value.toLowerCase() !== "none") {
        object[i18n.t("header-note")] = r.text;
      }
      return object;
    });

    let headers = [
      i18n.t("header-name"),
      i18n.t("date"),
      i18n.t("time"),
      i18n.t("course"),
    ];

    if (settings.AUTOTEAMSREADY) {
      headers.push(i18n.t("teams"));
    }
    headers.push(i18n.t("registration-course"))
    headers.push(i18n.t("header-reg"))
    headers.push(i18n.t("header-tags"))

    if (freeTextNotes.value.toLowerCase() !== "none") {
      headers.push(i18n.t("header-note"));
    }

    GenerateExcelFile(i18n.t("sub-nav3") + "_" + moment().format('DD-MM-YYYY-HHmm'), headers, data, i18n.t("sub-nav3") + "_" + moment().format('DD-MM-YYYY-HHmm'));
  }

  return (<>
    <Content>
      <TitleLeft>
        <span>{i18n.t("sub-nav3")}</span>
        <span>{getTextCount()}</span>
      </TitleLeft>


      {props.loading ? <RainbowLoader /> : getSortedRegistrations()?.length > 0 ? <><DataListWrap>
        <DashList>
          <tbody>
            <tr>
              <td className={"imgWidth"}></td>
              <Td className={"width20"} onClick={() => handleSort(0)}>{i18n.t("header-name")} <SortArrow sortActive={sort.type === 0} asc={sort.type === 0 && sort.direction === false} /></Td>
              <Td className={"width0"} onClick={() => handleSort(2)}>{i18n.t("timeframe")} <SortArrow sortActive={sort.type === 2} asc={sort.type === 2 && sort.direction === false} /></Td>
              <Td className={"width10"} onClick={() => handleSort(1)}>{i18n.t("course")} <SortArrow sortActive={sort.type === 1} asc={sort.type === 1 && sort.direction === false} /></Td>
              <Td className={""} onClick={() => handleSort(4)}>{i18n.t("registration-course")} <SortArrow sortActive={sort.type === 4} asc={sort.type === 4 && sort.direction === false} /></Td>
              {settings.AUTOTEAMSREADY ? <Td onClick={() => handleSort(8)} className={"center width1"} >{ }Teams<SortArrow sortActive={sort.type === 8} asc={sort.type === 8 && sort.direction === false} /></Td> : <></>}
              <Td className={"center width5"} onClick={() => handleSort(5)}>{i18n.t("header-reg")} <SortArrow sortActive={sort.type === 5} asc={sort.type === 5 && sort.direction === false} /></Td>
              <Td>{i18n.t("header-tags")}</Td>
              {freeTextNotes.value.toLowerCase() !== "none" ? <Td>{i18n.t("header-note")}</Td> : null}
            </tr>
            {schoolViewRegistrations ? getSortedRegistrations().slice((page * pageSize - pageSize), pageSize * page).map((r, index) => {
              let registeredBy = i18n.t("registered") + " " + i18n.t("by") + " " + r.regi_username + " " + i18n.t("on") + " " + moment(r.last_registertime).format('DD-MM-YYYY HH:mm');
              return <tr key={"registration_" + index}>
                <td className={"imgWidth"}><Img><StudentThumbnail font={"0.9em"} name={r?.student_displayname}  src={r.username} /></Img></td>
                <td className={"clickable"} onClick={() => props.handleClick(r.username, r.student_id, r.student_displayname, "STUDENT")}><Tooltip placement='top-start' content={i18n.t("show-details-" + studentCallName)}>{r.student_displayname}</Tooltip></td>
                <td className={"width0"} ><span>{moment(r.date).format('DD-MM-YYYY')} {moment.utc(moment.duration(r.starttime).as('milliseconds')).format('HH:mm') + " - " + moment.utc(moment.duration(r.endtime).as('milliseconds')).format('HH:mm')}</span></td>
                <td className={"width10"}>{r.course_name}</td>
                <td className={""}><span className={"p-right"}>{r.course_description}</span></td>
                {settings.AUTOTEAMSREADY ? <td className={"center width1"} >{r.teams_bit ? <AttendanceIcon ><Teams_Icon /></AttendanceIcon> : ""}</td> : <></>}
                <td className={"center width5"}><AttendanceIcon ><Tooltip content={r.regi_username ? registeredBy : ""}>{icons[AttendanceMap[r.absence_type]]}</Tooltip></AttendanceIcon></td>
                <td><Tags>{ConvertTags(r.tag_ids, index)} {tagsCount.current > 3?<><Tooltip offsetY={-5} element={ConvertTags(r.tag_ids, index, true)}><MoreTags><More_Icon /></MoreTags></Tooltip></>:<></>}</Tags></td>
                {freeTextNotes.value.toLowerCase() !== "none" ? <td style={{wordBreak:"break-all"}}>{r.text}</td> : null}
              </tr>
            }) : null}
          </tbody>
        </DashList>
      </DataListWrap>

        <Pagination pageSize={pageSize} count={getSortedRegistrations()?.length} currentPage={page} maxPage={Math.ceil(getSortedRegistrations()?.length / pageSize)} setPage={setPage} /></> : <EmptyBox Graphic={'documents'} marvin={true} text={i18n.t("no-filter-data")} />}

    </Content>
  </>);
});

export default RegistrationDetails;